import { useQuery } from "@tanstack/react-query";
import { fetchAccount, fetchMe } from "../api/index.js";
import { queryKeys } from "../query-keys.js";

/** Who is signed in. */

export function useMe(enabled = true) {
  return useQuery({
    queryKey: queryKeys.me(),
    queryFn: fetchMe,
    enabled,
    // A signed-out user is a resolved answer, not an error to retry.
    retry: false,
    staleTime: 60_000,
  });
}

/** Your own account, for the profile page. */
export function useAccount() {
  return useQuery({
    queryKey: queryKeys.account(),
    queryFn: fetchAccount,
    // The session count moves when another browser signs in; a minute is fresh
    // enough for a number nobody watches change.
    staleTime: 60_000,
  });
}
